import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function usePersistantState(key, initialValue) {
    // const [state, setInternalState] = useState(initialValue);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    const [state, setInternalState] = useState(() => {
        const storedValue = localStorage.getItem("data")
            ? JSON.parse(localStorage.getItem("data"))?.[jobId]?.[key]
            : false;

        return storedValue ? storedValue : initialValue;
    });

    useEffect(() => {
        const value = localStorage.getItem("data")
            ? JSON.parse(localStorage.getItem("data"))?.[jobId]?.[key]
            : false;

        if (!value) return;

        setInternalState(value);
    }, [key]);

    const setState = (value) => {
        let temp = localStorage.getItem("data")
            ? JSON.parse?.(localStorage.getItem("data"))
            : null;
        if (temp && temp[jobId]) {
            temp[jobId][key] = value;
            localStorage.setItem("data", JSON.stringify(temp));
            setInternalState(value);
        } else if (temp) {
            temp[jobId] = {};
            temp[jobId][key] = value;
            localStorage.setItem("data", JSON.stringify(temp));
            setInternalState(value);
        }
        // localStorage.setItem(key, JSON.stringify(value));
    };

    return [state, setState];
}
